import { getPersistedData, PersistedData, setPersistedData } from "utils/persist";

// detect preferred language
const getPreferredLang = () => {
    const saved = getPersistedData(PersistedData.Language);
    const browser = window.navigator.language.slice(0, 2);
    return saved || browser;
};

// preferred language
export const preferredLang = getPreferredLang();

// fallback language
const fallbackLang = "en";

// change language
export const changeLanguage = (lang: string) => {
    setPersistedData(PersistedData.Language, lang);
    window.location.reload();
};

// localize i18n dict
export const localize = <T extends object>(i18n: T) => {
    type Keys = keyof T;

    const localizedI18n: { [Key in Keys]?: any } = {};
    (Object.keys(i18n) as Keys[]).forEach((key) => {
        localizedI18n[key] = (i18n[key] as any)[preferredLang] || (i18n[key] as any)[fallbackLang];
    });
    return localizedI18n;
};
